import {
  Pagination as DSPagination,
  type PaginationProps,
  desktopFirstMediaQuery,
} from '@inflearn/ds-react-next';

type Props = Pick<PaginationProps, 'value' | 'defaultValue' | 'total' | 'onChange'>;

export default function Pagination(props: Props) {
  return (
    <>
      <DSPagination
        styles={{
          root: {
            display: 'none',
            [desktopFirstMediaQuery.mobile]: { display: 'flex', justifyContent: 'center' },
          },
        }}
        my={32}
        radius="md"
        size="md"
        withControls={false}
        withEdges={false}
        {...props}
      />
      <DSPagination
        styles={{
          root: {
            display: 'flex',
            justifyContent: 'center',
            [desktopFirstMediaQuery.mobile]: { display: 'none' },
          },
        }}
        my={32}
        radius="md"
        size="lg"
        withControls
        withEdges={false}
        {...props}
      />
    </>
  );
}
